import { defaultRenderSettings, RenderSettings } from '@inter-ikea-storageone/range';
import { getQuery, rangeIsBesta } from 'utils/queryUtils';

const query = getQuery();
const enablePointLight = query.get('enablePointLight') === 'true';
const generateInteriorAssembly = query.get('generateInteriorAssembly') === 'true';

export const plannerRenderSettings: RenderSettings = generateInteriorAssembly
  ? {
      ...defaultRenderSettings,
      directionalLight: {
        ...defaultRenderSettings.directionalLight,
        enabled: false
      },
      pointLight: {
        ...defaultRenderSettings.pointLight,
        enabled: true
      },
      environmentMap: {
        ...defaultRenderSettings.environmentMap,
        intensity: 1.5
      },
      temporalEffects: {
        temporalAntiAliasing: true,
        screenSpaceAmbientOcclusion: true,
        ssaoParams: {
          ...defaultRenderSettings.temporalEffects.ssaoParams,
          ambientOccluionStrength: 1.5
        }
      }
    }
  : {
      ...defaultRenderSettings,
      directionalLight: {
        ...defaultRenderSettings.directionalLight,
        enableShadows: true
      },
      pointLight: {
        ...defaultRenderSettings.pointLight,
        enabled: enablePointLight
      },
      darkMode: {
        ...defaultRenderSettings.darkMode,
        glow: {
          ...defaultRenderSettings.darkMode.glow,
          intensity: rangeIsBesta() ? 3.5 : defaultRenderSettings.darkMode.glow.intensity // BESTÅ need more intensity
        }
      }
    };
